import React from 'react';

interface IProps {
  dirty: boolean;
  readOnly: boolean;
  submitting: boolean;
}

const updatableComponent = <P extends IProps, F>(props: P, updatableFields: F[]) => {
  const fieldDisabled = (field: F) => {
    return props.readOnly || props.submitting || !updatableFields.includes(field);
  };

  const renderComponent = (Component: any) => {
    return <Component {...props} fieldDisabled={fieldDisabled} />;
  };

  return renderComponent;
};

export { updatableComponent };
